import React from "react";
import {
    ArrayField,
    Datagrid,
    DateField,
    Labeled,
    NumberField,
    ReferenceField,
    Show,
    SimpleShowLayout,
    TextField
} from "react-admin";
import {Divider, Grid} from "@material-ui/core";
import ShowFooterActions from "./ShowFooterActions";


const TwoColRow = props => {
    const {record, resource, basePath, children} = props;

    return (
        <Grid container spacing={16}>
            {React.Children.map(children, (child, index) => {
                if (!React.isValidElement(child)) return null;

                return (
                    <Grid item xs={12} sm={6} key={index}>
                        <Labeled
                            label={child.props.label}
                            source={child.props.source}
                            resource={resource}
                        >
                            {React.cloneElement(child, {
                                record,
                                resource,
                                basePath,
                                addLabel: false,
                            })}
                        </Labeled>
                    </Grid>
                );
            })}
        </Grid>
    );
};

export const PurchaseCancelRequestAuthorizeShow = props => (
    <Show {...props} actions={null}>
        <SimpleShowLayout>
            <TwoColRow>
                <TextField source="id" label="ID"/>
                <TextField source="status" label="Trạng thái"/>
            </TwoColRow>

            <TwoColRow>
                <DateField source="cancelFromDate" label="Từ ngày"/>
                <DateField source="cancelToDate" label="Đến ngày"/>
            </TwoColRow>

            <TwoColRow>
                <TextField source="reason" label="Lý do huỷ"/>
                <ReferenceField
                    label="Kiot Config"
                    source="kiotConfigId"
                    reference="kiotConfigs"
                >
                    <TextField source="name"/>
                </ReferenceField>
            </TwoColRow>

            <TwoColRow>
                <NumberField source="requestUserId" label="Người gửi (ID)"/>
                <DateField source="requestTime" label="Thời gian gửi" showTime/>
            </TwoColRow>

            <TwoColRow>
                <NumberField source="authorizedUserId" label="Người duyệt (ID)"/>
                <DateField source="authorizedTime" label="Thời gian duyệt" showTime/>
            </TwoColRow>

            <TwoColRow>
                <NumberField source="dayCount" label="Số ngày huỷ"/>
                <NumberField source="purchaseCount" label="Số đơn mua"/>
            </TwoColRow>

            <NumberField
                source="refundAmount"
                label="Tổng tiền hoàn"
                options={{style: "currency", currency: "VND"}}
            />

            <Divider style={{margin: "24px 0"}}/>

            {/* ===== CHI TIẾT THEO NGÀY ===== */}
            <ArrayField source="details" label="Chi tiết theo ngày">
                <Datagrid>
                    <DateField source="date" label="Ngày"/>
                    <NumberField source="purchaseCount" label="Số đơn mua"/>
                    <NumberField
                        source="refundAmount"
                        label="Tiền hoàn"
                        options={{style: "currency", currency: "VND"}}
                    />
                </Datagrid>
            </ArrayField>
            <ShowFooterActions/>
        </SimpleShowLayout>
    </Show>
);


export default PurchaseCancelRequestAuthorizeShow
